module.exports = __webpack_public_path__ + "img/taoyuan-2.8d8d7234.jpg";